import { render, staticRenderFns } from "./testo.vue?vue&type=template&id=1bbb9521&"
import script from "./testo.vue?vue&type=script&lang=js&"
export * from "./testo.vue?vue&type=script&lang=js&"
import style0 from "./testo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports